<template>
  <div class="d-flex flex-column flex-column-fluid qbank-section">
    <!-- Toolbar -->
    <div id="kt_app_toolbar" class="app-toolbar py-6 py-lg-6">
      <div id="kt_app_toolbar_container" class="app-container container-fluid d-flex flex-stack">
        <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
          <h1 class="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">
            منصة أكاديميا Academia
          </h1>
          <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
            <li class="breadcrumb-item text-muted">
              <a href="#" class="text-muted text-hover-primary">الصفحة الرئيسية</a>
            </li>
            <li class="breadcrumb-item">
              <span class="bullet bg-gray-400 w-5px h-2px"></span>
            </li>
            <li class="breadcrumb-item text-muted">بنك الأسئلة</li>
          </ul>
        </div>
        <div class="d-flex align-items-center gap-2 gap-lg-3">
          <button @click="$router.go(-1)" class="btn btn-light"
            style="font-weight: 600;padding: 8px 20px;margin-left: 15px;background: #d7d7d745;">
            رجوع <i class="fa fa-arrow-left" style="color: #07c232; margin-right: 10px"></i></button>
        </div>
      </div>
    </div>
    <!-- Content -->

    <div id="kt_app_content" class="app-content flex-column-fluid">
      <div id="kt_app_content_container" class="app-container container-fluid">
        <div v-if="isLoading == true"
          style="font-weight: 800;border-radius: 10px;padding: 50px;font-size: large;text-align: center;background: #73737326;"
          class="loader text-success">
          جاري التحميل
          <div class="spinner-border text-success" role="status">
            <span class="sr-only"></span>
          </div>
        </div>
        <div v-if="isLoggedIn == false && isLoading == false" class="col-12">
          <div class="card text-center p-5 not-login">
            <span class="icon"><i class="bi bi-person-badge"></i></span>
            <h3 class="mb-4">يرجى تسجيل الدخول للإستمرار </h3>
            <span>
              <a href="login" class="btn btn-success">
                تسجيل الدخول <i class="fa fa-sign-in"></i>
              </a>
            </span>
          </div>
        </div>
        <div class="row g-5 g-xl-10 mb-5 mb-xl-10">
          <div class="col-md-12" v-if="isLoading == false && isLoggedIn == true">
            <a style="background-color: #07c232;font-weight: 700;"
              class=" btn btn-sm btn-success btn-lg me-2 w-150px mb-2" data-bs-toggle="modal"
              data-bs-target="#show-fav-modal" @click.prevent="getFavorites()"><i class="fa fa-heart"></i> الأسئلة
              المفضلة </a>
            <div class="row">

              <div class="col-xl-5">

                <!--begin::Engage widget 1-->
                <div class="card h-xl-80" dir="ltr">
                  <!--begin::Body-->
                  <div class="card-body d-flex flex-column flex-center">
                    <!--begin::Heading-->
                    <div class="mb-2">
                      <!--begin::Title-->
                      <h1 class="fw-semibold text-gray-800 text-center lh-lg"> بنك الأسئلة
                        <br>
                        <span class="fw-bolder"> إشتراك جديد</span>
                      </h1>
                      <!--end::Title-->
                      <!--begin::Illustration-->
                      <div class="py-10 text-center">
                        <img src="assets/img/online.png" class="theme-light-show w-150px" alt="">
                        <img src="assets/img/online.png" class="theme-dark-show w-150px" alt="">
                      </div>
                      <!--end::Illustration-->
                    </div>
                    <!--end::Heading-->
                    <!--begin::Links-->
                    <div class="text-center mb-1">
                      <!--begin::Link-->
                      <a style="background-color: #07c232" class=" btn btn-sm btn-success btn-lg me-2 w-150px"
                        href="qbank-plan">إشتراك جديد <i class="fa fa-plus-circle"></i> </a>
                      <!--end::Link-->

                    </div>
                    <!--end::Links-->
                  </div>
                  <!--end::Body-->
                </div>
                <!--end::Engage widget 1-->
              </div>
              <div class="col-xl-7 mb-xl-10">
                <!--begin::List widget 20-->
                <div class="card h-xl-100">
                  <!--begin::Header-->
                  <div class="card-header border-0 pt-5">
                    <h3 class="card-title align-items-start flex-column">
                      <span class="card-label fw-bold text-dark"> إشتراكاتي</span>
                      <span class="text-muted mt-1 fw-semibold fs-7">قائمة بكل الاشتراكات المتاحة</span>
                    </h3>
                    <!--begin::Toolbar-->

                    <!--end::Toolbar-->
                  </div>
                  <!--end::Header-->
                  <!--begin::Body-->
                  <!--begin::Body-->
                  <div class="card-body pt-6">
                    <!-- عرض البيانات -->
                    <SubscriptionsList :subscriptions="subscriptions" />

                  </div>
                  <!--end::Body-->

                  <!--end::Body-->
                </div>
                <!--end::List widget 20-->
              </div>


            </div>


          </div>
        </div>
      </div>
    </div>
    <!--begin::Col-->

    <!--end::Col-->

  </div>
  <Favorites ref="favRef" />

</template>

<script>
import { apiUrl, baseUrl } from "@/utils/api";

import SubscriptionsList from "./SubscriptionsList.vue";
import Favorites from "./Favorites.vue";

export default {
  name: "Home",
  components: {
    SubscriptionsList,
    Favorites,
  },
  data() {
    return {
      categories: [],
      subCategories: [],
      isLoading: true,
      token: localStorage.getItem("access_token"),
      courseCount: 0,
      isLoggedIn: false,
      walletBalance: 0,
      catImagePath: baseUrl + "/images/category/",
      defaultImage: "/assets/img/acad-icon.png",
      student: {},
      loadingCategories: true, // Loading state for categories
      loadingCourses: true, // Loading state for courses
      loadingBalance: true, // Loading state for wallet balance
      currentStep: 1, // بداية في الخطوة 1
      selectedOption: "", // البيانات للـ select box
      textInput: "", // البيانات للـ input text
      numberInput: "", // البيانات للـ input number
      isChecked: false, // البيانات للـ checkbox
    };
  },
  mounted() {
    this.getSubscriptions();
  },
  methods: {
    async getFavorites() {
      this.$refs.favRef.getFavorites()
    },
    async getSubscriptions() {
      this.loadingBalance = true;
      try {
        const response = await fetch(
          `${apiUrl}/profile/qbanks/subscription-plans`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${this.token}`,
              "Content-Type": "application/json",
            },
          }
        );
        if (response.status === 302 || response.redirected || !response.ok) {
          this.isLoggedIn = false;
          this.isLoading = false;
          return;
        }
        this.isLoggedIn = true;
        const data = await response.json();
        this.subscriptions = data.data;

        // تصنيف الاشتراكات
        this.expiredSubscriptions = this.subscriptions.filter(
          (subscription) => !subscription.is_active
        );
        this.activeSubscriptions = this.subscriptions.filter(
          (subscription) => subscription.is_active
        );
      } catch (error) {
        console.error("Error fetching subscriptions:", error);
      } finally {
        this.loadingBalance = false;
        this.isLoading = false;

      }
    },
    formatDate(date) {
      const options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      };
      return new Date(date).toLocaleDateString("en-US", options);
    },
    handleImageError(event) {
      // استبدال الصورة بصورة افتراضية إذا حدث خطأ مثل 404
      event.target.src = this.defaultImage;
    }
  },
};
</script>

<style scoped></style>
